import { logAction } from '../api/logApi';

const styles = {
  section: {
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  videoList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  videoThumb: {
    maxWidth: '100%',
    borderRadius: '4px',
  },
};

const formatDuration = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

function VTuberVideoList({ vtuberId, videos }) {
  return (
    <section style={styles.section}>
      <h3>配信動画</h3>
      <div style={styles.videoList}>
        {videos.map((video) => (
          <a
            key={video.videoId}
            href={`https://www.youtube.com/watch?v=${video.videoId}`}
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              logAction('video_click', {
                vtuberId,
                videoId: video.videoId,
                source: 'detail',
              })
            }
          >
            <img
              style={styles.videoThumb}
              src={video.thumbnailUrl}
              alt={video.title}
            />
            <p>
              {video.title} ({formatDuration(video.durationSeconds)})
            </p>
          </a>
        ))}
      </div>
    </section>
  );
}

export default VTuberVideoList;
